var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28957 0.711731C0.89957 1.10173 0.89957 1.73173 1.28957 2.12173L5.16957 6.00173L1.28957 9.88173C0.89957 10.2717 0.89957 10.9017 1.28957 11.2917C1.67957 11.6817 2.30957 11.6817 2.69957 11.2917L7.28957 6.70173C7.67957 6.31173 7.67957 5.68173 7.28957 5.29173L2.69957 0.701731C2.31957 0.321731 1.67957 0.321731 1.28957 0.711731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.f6c3d54d7d430e157d1073b3e1ce3517.svg";
export { ForwardRef as ReactComponent };